import React from "react";
import classNames from "classnames";

import { ArrowIcon } from "@common/assets/arrowIcon";
import { ResourceAvatar } from "@common/resourceAvatar";
import { Props } from "./types";
import styles from "./styles.scss";

function Input({ selected, placeholder, isOpen }: Props) {
  return (
    <div
      className={classNames(styles.input, {
        [styles.opened]: isOpen,
      })}
    >
      {!selected && <p className={styles.placeholder}>{placeholder}</p>}
      {!!selected && (
        <div className={styles.selected}>
          <div className={styles.avatar}>
            <ResourceAvatar resource={selected} />
          </div>
          <p className={styles.name}>{selected.name}</p>
        </div>
      )}
      <ArrowIcon className={styles.toggleIcon} />
    </div>
  );
}

export { Input };
